import classNames from 'classnames';
import PropTypes from 'prop-types';

const CreateCreativeIcon = ({ width, height, className }) => {
  return (
    <svg
      className={classNames('creat-creative-icon', className)}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 202 205'
    >
      <path
        fill='#CAD4D0'
        d='M172.291 133.521c0 19.969-8.156 37.97-21.235 50.908-12.797 12.798-30.517 20.532-50.065 20.532-19.407 0-37.126-7.875-50.064-20.532-13.079-12.938-21.236-30.939-21.236-50.908 0-39.518 31.924-71.44 71.3-71.44 39.377 0 71.3 32.063 71.3 71.44zM179.676 106.422a5.766 5.766 0 100-11.532 5.766 5.766 0 000 11.532z'
      ></path>
      <path fill='#EAEEF9' d='M174.539 64.19a3.938 3.938 0 100-7.876 3.938 3.938 0 000 7.876z'></path>
      <path
        fill='#CAD4D0'
        d='M31.938 86.55a3.938 3.938 0 100-7.875 3.938 3.938 0 000 7.875zM7.891 162.491a7.313 7.313 0 100-14.626 7.313 7.313 0 000 14.626z'
      ></path>
      <path
        fill='#1B4332'
        d='M155.051 91.463l-5.865 42.601-7.331 52.64c-1.71.979-3.665 1.714-5.62 1.714H51.683c-3.665 0-6.842-1.224-9.53-3.183-.733-.49-1.466-1.224-2.2-1.959-2.932-2.938-4.887-7.345-4.887-11.997V80.201c0-4.163 3.422-7.345 7.331-7.345h25.66c1.71 0 3.42.734 4.886 2.203l8.309 9.059c1.222 1.224 2.932 1.959 4.643 1.959h64.269c2.932 0 5.131 2.448 4.887 5.386z'
      ></path>
      <g filter='url(#filter0_d_3871_19395)'>
        <path
          fill='url(#paint0_linear_3871_19395)'
          d='M47.527 179.114l6.843-79.082c.244-2.938 2.688-5.141 5.62-5.141h97.258c2.689 0 4.643 2.203 4.399 4.896l-6.842 67.33-107.278 11.997z'
        ></path>
      </g>
      <g filter='url(#filter1_d_3871_19395)'>
        <path
          fill='url(#paint1_linear_3871_19395)'
          d='M86.385 170.544l-35.678 8.325L72.7 118.394c.978-2.693 3.421-4.407 6.354-4.407h86.262c3.176 0 5.376 3.428 3.909 6.366l-23.459 47.988-59.381 2.203z'
        ></path>
      </g>
      <g filter='url(#filter2_d_3871_19395)'>
        <path
          fill='#1B4332'
          d='M177.532 139.94l-32.745 44.071c-.733.979-1.955 1.958-2.933 2.693-1.71.979-3.665 1.714-5.62 1.714H51.683c-3.666 0-6.843-1.224-9.53-3.183l32.244-37.614a6.572 6.572 0 014.99-2.294h50.738c2.443 0 4.887-.735 6.842-2.449l9.286-7.1c.977-.734 1.955-1.224 2.932-1.714 1.222-.489 2.688-.734 3.91-.734h21.016c3.421-.245 5.376 3.917 3.421 6.61z'
        ></path>
      </g>
      <path
        fill='#CAD4D0'
        d='M159.323 81.686l-38.36-24.847a4.782 4.782 0 01-1.413-6.606l23.821-36.676a4.794 4.794 0 016.612-1.418l38.36 24.847a4.782 4.782 0 011.414 6.606l-23.811 36.701c-1.446 2.206-4.417 2.836-6.623 1.393z'
      ></path>
      <path
        fill='#fff'
        d='M160.768 74.819L127.042 52.97c-.953-.607-1.21-1.88-.602-2.832l19.699-30.326c.608-.953 1.882-1.21 2.835-.604L182.7 41.057c.954.606 1.211 1.88.603 2.832l-19.699 30.325c-.608.953-1.883 1.211-2.836.605z'
      ></path>
      <path fill='#B0B7C4' d='M152.038 52.852l-12.31-7.979 10.666-2.99 1.644 10.97z'></path>
      <path fill='#CED6E2' d='M162.222 59.444l-17.735-11.476 15.357-4.296 2.378 15.772z'></path>
      <path
        fill='#B0B7C4'
        d='M149.487 37.093a2.769 2.769 0 003.613 1.511 2.77 2.77 0 10-2.098-5.123 2.77 2.77 0 00-1.515 3.612z'
      ></path>
      <path
        fill='#fff'
        d='M124.043 180.41c-.482 2.048-1.205 4.216-2.048 6.023-2.289 4.457-5.903 7.951-10.36 10.24-4.578 2.289-9.999 3.252-15.42 2.048-12.77-2.651-20.961-15.179-18.31-27.948 2.65-12.77 15.057-21.082 27.827-18.311 4.577.964 8.553 3.253 11.926 6.385 5.662 5.661 8.071 13.853 6.385 21.563z'
      ></path>
      <path
        fill='#1B4332'
        d='M108.501 173.543h-5.421v-5.421c0-1.084-.843-2.048-2.048-2.048-1.084 0-2.047.843-2.047 2.048v5.421h-5.421c-1.085 0-2.048.843-2.048 2.048s.843 2.048 2.047 2.048h5.421v5.421c0 1.084.844 2.048 2.048 2.048 1.085 0 2.048-.843 2.048-2.048v-5.421h5.421c1.084 0 2.048-.843 2.048-2.048s-.964-2.048-2.048-2.048z'
      ></path>
      <defs>
        <filter
          id='filter0_d_3871_19395'
          width='132.916'
          height='102.999'
          x='34.384'
          y='85.503'
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          ></feColorMatrix>
          <feOffset dx='-3.755'></feOffset>
          <feGaussianBlur stdDeviation='4.694'></feGaussianBlur>
          <feColorMatrix values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0'></feColorMatrix>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_3871_19395'></feBlend>
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_3871_19395' result='shape'></feBlend>
        </filter>
        <filter
          id='filter1_d_3871_19395'
          width='137.76'
          height='83.658'
          x='37.564'
          y='104.599'
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          ></feColorMatrix>
          <feOffset dx='-3.755'></feOffset>
          <feGaussianBlur stdDeviation='4.694'></feGaussianBlur>
          <feColorMatrix values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.15 0'></feColorMatrix>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_3871_19395'></feBlend>
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_3871_19395' result='shape'></feBlend>
        </filter>
        <filter
          id='filter2_d_3871_19395'
          width='154.932'
          height='73.874'
          x='28.07'
          y='123.931'
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          ></feColorMatrix>
          <feOffset dx='-4.694'></feOffset>
          <feGaussianBlur stdDeviation='4.694'></feGaussianBlur>
          <feColorMatrix values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.2 0'></feColorMatrix>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_3871_19395'></feBlend>
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_3871_19395' result='shape'></feBlend>
        </filter>
        <linearGradient
          id='paint0_linear_3871_19395'
          x1='104.56'
          x2='104.56'
          y1='92.942'
          y2='180.022'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FDFEFF'></stop>
          <stop offset='0.996' stopColor='#ECF0F5'></stop>
        </linearGradient>
        <linearGradient
          id='paint1_linear_3871_19395'
          x1='110.16'
          x2='110.16'
          y1='112.487'
          y2='179.568'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FDFEFF'></stop>
          <stop offset='0.996' stopColor='#ECF0F5'></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

CreateCreativeIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};

export default CreateCreativeIcon;
